// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal__wrapper[data-v-25c5f49b] {
    display: flex;
    flex-direction: column;
    padding: 25px;
    gap: 25px;
}
.modal__content[data-v-25c5f49b] {
    text-align: center;
}
.modal__button-bar[data-v-25c5f49b] {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/SimpleConfirmModal.vue"],"names":[],"mappings":";AA2BA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,SAAA;AACA;AAEA;IACA,kBAAA;AACA;AAEA;IACA,aAAA;IACA,yBAAA;IACA,SAAA;AACA","sourcesContent":["<template>\n    <NcModal :name=\"title\" @close=\"$close(false)\">\n        <div class=\"modal__wrapper\">\n            <div class=\"modal__content\">{{ content }}</div>\n            <div class=\"modal__button-bar\">\n                <NcButton @click=\"$close(false)\">{{\n                    t('cookbook', 'Cancel')\n                }}</NcButton>\n                <NcButton type=\"primary\" @click=\"$close(true)\">{{\n                    t('cookbook', 'OK')\n                }}</NcButton>\n            </div>\n        </div>\n    </NcModal>\n</template>\n\n<script setup>\nimport { NcModal, NcButton } from '@nextcloud/vue';\n</script>\n\n<script>\nexport default {\n    name: 'SimpleConfirmModal',\n};\n</script>\n\n<style scoped>\n.modal__wrapper {\n    display: flex;\n    flex-direction: column;\n    padding: 25px;\n    gap: 25px;\n}\n\n.modal__content {\n    text-align: center;\n}\n\n.modal__button-bar {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
